import * as yup from 'yup';

import { REGEXP } from 'constants/commonConstants';

export default yup.object().shape({
  userName: yup
    .string()
    .required('아이디를 입력해주세요.')
    .matches(REGEXP.USERNAME, '4-20자의 영문, 숫자, -, _의 조합으로 이루어져야합니다.'),
  description: yup.string().matches(REGEXP.DESCRIPTION, '100자 이하로 작성해주세요.'),
});
